module.exports = __webpack_public_path__ + "static/media/sms-campaigns-list.179fb248.svg";